import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3758341090/src/packages/frontend/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/codebuild/output/src3758341090/src/packages/frontend/layouts/landing.vue").then(m => m.default || m)),
  print: defineAsyncComponent(() => import("/codebuild/output/src3758341090/src/packages/frontend/layouts/print.vue").then(m => m.default || m))
}